module.exports = __webpack_public_path__ + "img/cloud.475cae6d.svg";